import React from "react";
import styled from "styled-components";
import { createGRN } from "logic/permissions/GRN";
import useShowRouteFromGRN from "routing/hooks/useShowRouteFromGRN";
import useHasEntityPermissionByGRN from "hooks/useHasEntityPermissionByGRN";
import { Link, RestrictedAccessTooltip } from "components/common";
const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;
const TitleCell = ({ id, name, type }) => {
  const grn = createGRN(type, id);
  const hasReadPermission = useHasEntityPermissionByGRN(grn, "read");
  const entityRoute = useShowRouteFromGRN(grn);
  if (hasReadPermission) {
    return /* @__PURE__ */ React.createElement(Link, { to: entityRoute }, name);
  }
  return /* @__PURE__ */ React.createElement(Wrapper, null, name, " ", /* @__PURE__ */ React.createElement(RestrictedAccessTooltip, { entityName: type, capabilityName: "view" }));
};
export default TitleCell;
